import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Container } from '../../../ui/gridSystem';
import { Logo, Text } from '../../../ui/atoms';
import { AuthContainer, LogoContainer } from '../Auth/styles';
import { AUTH_LOGIN_SSO } from '../../redux/actions';
import routes from '../../../routes';
import { ToastError } from '../../../ui/components/Toast';

const AuthReset = ({ startLogin, appConfig }) => {
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const tokenSSO = queryParams.get('tokenSSO');

  useEffect(() => {
    if (tokenSSO && tokenSSO !== 'error') startLogin(tokenSSO, navigate);
    else {
      navigate(routes.auth.path);
      toast.error(
        <ToastError
          title="Accesso negato"
          body="Qualcosa è andato storto durante l'autenticazione"
        />,
        {
          toastId: 'errorLoginSSO',
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenSSO]);

  return (
    <AuthContainer>
      <Container>
        <LogoContainer>
          <Logo
            size={Logo.SIZE.XL}
            src={appConfig?.login_logo?.src}
            alt={appConfig?.login_logo?.alt}
          />
        </LogoContainer>
        <Text type="h1" className="text-center">
          Attendi
        </Text>
        <Text type="b2" className="text-center">
          Stai per essere reindirizzato
        </Text>
      </Container>
    </AuthContainer>
  );
};

AuthReset.propTypes = {
  // HOC (connect, state)
  appConfig: PropTypes.object,
  // HOC (connect, dispatch)
  startLogin: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const { appConfig } = state.app;
    return { appConfig };
  },
  (dispatch) => ({
    startLogin: (tokenSSO, navigate) =>
      dispatch({ type: AUTH_LOGIN_SSO._REQUEST, tokenSSO, navigate }),
  })
)(AuthReset);
